import React from "react";

const Resolution = ({ resolutions }) => {
  // Utility to strip HTML tags
  const stripHtml = (html = "") => html.replace(/<[^>]+>/g, "");

  return (
    <div className="final-report-content mb-3">
      <h2 className="font-18 font-weight-bold heading-color mb-2">
        Resolutions:
      </h2>
      <ul className="text-color">
        {resolutions && resolutions.length > 0 ? (
          resolutions.map((resolution, index) => (
            <li
              key={index}
              className="font-12 font-weight-light heading-color mb-2"
            >
              <strong>{resolution.subject || <i>No subject</i>}</strong>
              <br />
              <span className="text-muted">
                {resolution.resolution_description ? (
                  stripHtml(resolution.resolution_description)
                ) : (
                  <i>No description</i>
                )}
              </span>
            </li>
          ))
        ) : (
          <li className="font-13 font-weight-normal text-color mb-2">
            <i>No resolutions available.</i>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Resolution;
